import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {registerBookingTrip, requestApi, isWidget, getNextStep, bookingActions} from "../utils/utils";
import {getTripById} from "../redux/actions/tripActions";
import {setStep} from "../redux/actions/stepActions";
import BookingStepper from "../components/Booking/BookingStepper";
import {Button, Container, Grid, Paper} from "@mui/material";
import TripSummary from "../components/Booking/Summary/TripSummary";
import HoldBook from "../components/Booking/Payment/HoldBook";
import {getActivitiesByTrip} from "../redux/actions/activitiesActions";
import {setTotals} from "../redux/actions/totalActions";
import GuestBar from "../components/GuestInfo/GuestBar";
import {useIsAuthenticated} from "react-auth-kit";
import {TripPropTypes} from "../utils/PropTypes/TripPropTypes";
import ObserverDimensions from "../components/ObserverDimensions";

const HoldPage = () => {
    const {bookingId} = useParams();
    const {data: trip} = useSelector(state => state.trip);
    const dispatch = useDispatch();
    const [booking, setBooking] = useState({});
    const history = useHistory();
    const isAuth = useIsAuthenticated();
    const transactions = useSelector(state => state.transactions);
    const totals = useSelector((state) => state.totals);
    const selectedRooms = transactions?.selectedRooms || [];
    const bookingType = useSelector(state => state.bookingType);
    const step = useSelector(state => state.step);

    async function getBookingHold() {
        const {data} = await requestApi(`/booking/get/${bookingId}`);
		// console.log(data);
        if ('status' in data && data['status'] === 'success') {
            if (Object.keys(data['booking']).length > 0) {
                setBooking(data['booking']);
                if (trip?.TripId !== parseInt(data['booking']['TripId']))
                    dispatch(getTripById(data['booking']['TripId']));
            }
        }
    }

    useEffect(() => {
		const findStep = isWidget() ? 5 : 6;
        dispatch(setStep(findStep));
        if (Object.keys(booking).length === 0)
            getBookingHold().catch();
        registerBookingTrip();
    }, []);

    useEffect(() => {
        if (trip?.TripId) {
            dispatch(getActivitiesByTrip(trip.TripId))
                .then(() => {
                    dispatch(setTotals());
                });
        }
    }, [trip?.TripId]);

    function goToPayment() {
        const currentStep = getNextStep(step-1);
        bookingActions(
            currentStep.label,
            'Next Step',
            `${trip.TripId} - PAX: ${selectedRooms.length} - BookingType: ${bookingType}`,
            trip.locationInfo.location,
            trip.boarddate,
            parseFloat(totals.roomsAmount ?? 0).formatMoney(0))
        history.push(`/booking/payment/${bookingId}`);
    }

    const goToTerms = () => {
        history.push(`/booking/${booking?.TripId}/terms`);
    };

    return (
        <div>
            {isAuth() && <GuestBar/>}
            <Container maxWidth="lg">
                <BookingStepper/>
                <div style={{marginTop: 50}}/>
                {booking && Object.keys(booking).length > 0 && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={9}>
                            <HoldBook booking={booking} isWidget={isWidget()}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3}>
                            {trip && Object.keys(trip).length > 0 && <TripSummary showCosts/>}
                            {!isWidget() && <Paper>
                                <Button color={'primary'} variant={'contained'} fullWidth onClick={goToPayment}>
                                    Pay Now
                                </Button>
                                <Button color={'secondary'} variant={'contained'} fullWidth onClick={goToTerms}>
                                    Go Back to Terms & Conditions
                                </Button>
                            </Paper>}
                        </Grid>
                    </Grid>
                )}
            </Container>
            {isWidget() && <ObserverDimensions/>}
        </div>
    );
};

export default HoldPage;

HoldPage.propTypes = {
    trip: TripPropTypes,
};